import { string, array, func, bool, object } from 'prop-types';

export const LISTINGS = {
    briefId: string.isRequired,
    projects: array,
    statistics: object,
    onSaveProject: func,
    requireRegistration: bool,
};

export const TEXT_FIELDS = {
    brandName: string,
    slogan: string,
    isMobile: bool,
    isTouch: bool,
    onChange: func,
    onEditBriefClick: func,
};

const TOOLBAR_PROPS = {
    brandName: string,
    brandNameError: string,
    onBrandNameChange: func,
    slogan: string,
    onSloganChange: func,
    inputProps: object,
};

export const TOUCH_TOOLBAR = {
    ...TOOLBAR_PROPS,
    onApplyChanges: func,
    onCancelChanges: func,
    onEditBrief: func,
    isMobile: bool,
};

export const MOBILE_TOOLBAR = {
    ...TOOLBAR_PROPS,
    inputLabels: object,
    onApply: func,
    onClose: func,
};

export const TABLET_TOOLBAR = {
    ...TOOLBAR_PROPS,
    inputLabels: object,
    onApply: func,
    onClose: func,
};
